<template>
<Layout>
    <div class="container">
    <div class="row">
          <div class="col-12 mt-3">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">Product</h3>

                <div class="card-tools">
                  <div class="input-group input-group-sm" style="width: 150px;">
                    <input type="text" name="table_search" class="form-control float-right" placeholder="Search">

                    <div class="input-group-append">
                      <button type="submit" class="btn btn-default"><i class="fas fa-search"></i></button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                <table class="table table-head-fixed">
                  <thead>
                    <tr>
                      <th>ID</th>
                      <th>Name</th>
                      <th>Type</th>
                      <th>Style Trade</th>
                      <th>Description</th>
                      <th>Last Modified</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr >
                      <td >1</td>
                      <router-link to="/product/:id"><td>EA Copy Trade Fxhanuman_Sumo</td></router-link>
                      <td>EA</td>
                      <td><span class="tag tag-success">Copy Trade</span></td>
                      <td>EA Copy Trade Fxhanuman_Sumo  เป็นอีเอสำหรับ Copy Trade  ได้ทุกๆโบรกเกอร์</td>
                      <td>24/05/1993.</td>
                    </tr>
                    
                    <tr>
                      <td>657</td>
                      <td>Bob Doe</td>
                      <td>11-7-2014</td>
                      <td><span class="tag tag-primary">Approved</span></td>
                      <td>Bacon ipsum dolor sit amet salami venison chicken flank fatback doner.</td>
                      <td>24/05/1993.</td>
                    </tr>
                   
                  </tbody>
                </table>
              </div>
              <!-- /.card-body -->
            </div>
            <!-- /.card -->
          </div>
        </div>
        </div>
    </Layout>
</template>

<script>
import Layout from '@/components/Layout'
export default {
  name: 'showproduct',
  components : {
    Layout
  }
}
</script>